import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CapacityAnalysisChart = ({ data }) => {
  const COLORS = {
    current: 'var(--color-primary)',
    required: 'var(--color-accent)',
    gap: 'var(--color-error)'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-4">
          <p className="text-sm font-semibold text-foreground mb-2">{payload?.[0]?.payload?.equipment}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <span className="text-xs text-muted-foreground">{entry?.name}:</span>
              <span className="text-sm font-medium text-foreground data-text">
                {entry?.value?.toLocaleString('id-ID')} {payload?.[0]?.payload?.unit}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-80 md:h-96" aria-label="Capacity Analysis Bar Chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="equipment" 
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fill: 'var(--color-foreground)', fontSize: 12 }}
          />
          <YAxis 
            tick={{ fill: 'var(--color-foreground)', fontSize: 12 }}
            label={{ 
              value: 'Kapasitas', 
              angle: -90, 
              position: 'insideLeft',
              style: { fill: 'var(--color-foreground)', fontSize: 14 }
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ paddingTop: '20px' }}
            iconType="circle"
          />
          <Bar 
            dataKey="current" 
            name="Kapasitas Saat Ini" 
            fill={COLORS?.current}
            radius={[8, 8, 0, 0]}
          />
          <Bar 
            dataKey="required" 
            name="Kapasitas Dibutuhkan" 
            fill={COLORS?.required}
            radius={[8, 8, 0, 0]}
          />
          <Bar 
            dataKey="gap" 
            name="Kesenjangan" 
            fill={COLORS?.gap}
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CapacityAnalysisChart;